import React from "react";

import AIBlockchaininHealthcare from "../../components/BlogDetails/AIBlockchaininHealthcare";
import LayoutTwo from "../../layouts/LayoutTwo";

const BlogDetailsPage = () => {
  return (
    <LayoutTwo pageTitle={"Blog Details"} item={"BLOG DETAILS"}>
      <AIBlockchaininHealthcare />
    </LayoutTwo>
  );
};

export default BlogDetailsPage;
